/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType = Types.Exact<{
  artifactInstanceId: Types.Scalars['UUID'];
}>;


export type GetFinalOutputDeliverableArtifactInstanceQueryGQLType = (
  { __typename?: 'Query' }
  & { finalOutputDeliverableArtifactInstance: (
    { __typename?: 'FinalOutputDeliverableArtifactInstance' }
    & Pick<Types.FinalOutputDeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'status' | 'rawRecordStatus'>
  ) }
);


export const GetFinalOutputDeliverableArtifactInstanceDocumentGQLType = gql`
    query GetFinalOutputDeliverableArtifactInstance($artifactInstanceId: UUID!) {
  finalOutputDeliverableArtifactInstance(artifactInstanceId: $artifactInstanceId) {
    id
    deliverableArtifactId
    status
    rawRecordStatus
  }
}
    `;

/**
 * __useGetFinalOutputDeliverableArtifactInstanceQuery__
 *
 * To run a query within a React component, call `useGetFinalOutputDeliverableArtifactInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinalOutputDeliverableArtifactInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinalOutputDeliverableArtifactInstanceQuery({
 *   variables: {
 *      artifactInstanceId: // value for 'artifactInstanceId'
 *   },
 * });
 */
export function useGetFinalOutputDeliverableArtifactInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>(GetFinalOutputDeliverableArtifactInstanceDocumentGQLType, options);
      }
export function useGetFinalOutputDeliverableArtifactInstanceLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>(GetFinalOutputDeliverableArtifactInstanceDocumentGQLType, options);
        }
export type GetFinalOutputDeliverableArtifactInstanceQueryHookResult = ReturnType<typeof useGetFinalOutputDeliverableArtifactInstanceQuery>;
export type GetFinalOutputDeliverableArtifactInstanceLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinalOutputDeliverableArtifactInstanceLazyQueryGQLType>;
export type GetFinalOutputDeliverableArtifactInstanceQueryResultGQLType = Apollo.QueryResult<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>;